/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type chat_viewer = {|
  +tradeChatEmail: ?$ReadOnlyArray<?{|
    +userDataB: ?$ReadOnlyArray<?{|
      +email?: ?string;
    |}>;
  |}>;
  +vipChatEmail: ?$ReadOnlyArray<?{|
    +userDataB: ?$ReadOnlyArray<?{|
      +email?: ?string;
    |}>;
  |}>;
  +allTransactions: ?{|
    +totalResults: ?number;
  |};
  +initiatedTransactions: ?{|
    +totalResults: ?number;
  |};
  +submittedTransactions: ?{|
    +totalResults: ?number;
  |};
  +confirmedTransactions: ?{|
    +totalResults: ?number;
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userIds",
      "type": "[String]!"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "chat_viewer",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "tradeChatEmail",
      "args": [
        {
          "kind": "Literal",
          "name": "relationshipType",
          "value": "VIP",
          "type": "relationshipType!"
        },
        {
          "kind": "Variable",
          "name": "userIds",
          "variableName": "userIds",
          "type": "[String]!"
        }
      ],
      "concreteType": "UserRelationship",
      "name": "userRelationships",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": null,
          "name": "userDataB",
          "plural": true,
          "selections": [
            {
              "kind": "InlineFragment",
              "type": "VipRepData",
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "email",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": "vipChatEmail",
      "args": [
        {
          "kind": "Literal",
          "name": "relationshipType",
          "value": "TRADE",
          "type": "relationshipType!"
        },
        {
          "kind": "Variable",
          "name": "userIds",
          "variableName": "userIds",
          "type": "[String]!"
        }
      ],
      "concreteType": "UserRelationship",
      "name": "userRelationships",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": null,
          "name": "userDataB",
          "plural": true,
          "selections": [
            {
              "kind": "InlineFragment",
              "type": "TradeRepData",
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "email",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": "allTransactions",
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userIds",
          "type": "[String]"
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 0,
          "type": "Int"
        }
      ],
      "concreteType": "TransactionConnection",
      "name": "transactions",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "totalResults",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": "initiatedTransactions",
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userIds",
          "type": "[String]"
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 0,
          "type": "Int"
        },
        {
          "kind": "Literal",
          "name": "viewName",
          "value": "buyerTracking.initiated",
          "type": "String"
        }
      ],
      "concreteType": "TransactionConnection",
      "name": "transactions",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "totalResults",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": "submittedTransactions",
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userIds",
          "type": "[String]"
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 0,
          "type": "Int"
        },
        {
          "kind": "Literal",
          "name": "viewName",
          "value": "buyerTracking.submitted",
          "type": "String"
        }
      ],
      "concreteType": "TransactionConnection",
      "name": "transactions",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "totalResults",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": "confirmedTransactions",
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userIds",
          "type": "[String]"
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 0,
          "type": "Int"
        },
        {
          "kind": "Literal",
          "name": "sort",
          "value": "createdDate asc",
          "type": "String"
        },
        {
          "kind": "Literal",
          "name": "viewName",
          "value": "buyerTracking.confirmed",
          "type": "String"
        }
      ],
      "concreteType": "TransactionConnection",
      "name": "transactions",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "totalResults",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;
